import { BeeyLocale } from './locale';
import { getCurrentUiLocale } from './ui';
const defaultRecognitionLocale = BeeyLocale.const('en-US');
export const selectLanguageWithPriority = (options, suggestedLocale = null) => {
    if (options.length === 0) {
        return null;
    }
    const selected = suggestedLocale !== null && suggestedLocale !== void 0 ? suggestedLocale : getCurrentUiLocale();
    const exactOption = options.find((opt) => opt.locale.equals(selected));
    if (exactOption !== undefined) {
        return exactOption;
    }
    const similarOption = options.find((opt) => opt.locale.lang === selected.lang);
    if (similarOption !== undefined) {
        return similarOption;
    }
    const defaultOption = options.find((opt) => opt.locale.equals(defaultRecognitionLocale));
    if (defaultOption !== undefined) {
        return defaultOption;
    }
    return options[0];
};
export const selectInitialTranscriptionOption = (options, suggestedLocale = null) => {
    return selectLanguageWithPriority(options, suggestedLocale);
};
export const getProfilesForLanguage = (profiles, language) => {
    return profiles.filter((profile) => profile.lang === language.code);
};
export const getSingleProfileForLanguage = (profiles, language) => {
    const profilesForLanguage = getProfilesForLanguage(profiles, language);
    return profilesForLanguage.length === 1 ? profilesForLanguage[0] : null;
};
export const selectInitialLanguage = (availableLanguages, suggestedLocale) => {
    var _a, _b;
    const selectedOption = selectLanguageWithPriority(availableLanguages.map((lang) => ({ locale: lang })), suggestedLocale);
    return (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.locale) !== null && _a !== void 0 ? _a : ((_b = availableLanguages[0]) !== null && _b !== void 0 ? _b : BeeyLocale.const('en-US'));
};
